<template>
	<div>
    <div class="topHeader" @click="toserch">
      <div>
        <md-icon name="search"  style="margin-right: 0.1rem;color: #ffffff"></md-icon>
        <span>{{message}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from 'mand-mobile'
export default {
  name: 'SearchModal',
  components: {
    [Icon.name]: Icon
  },
  data () {
    return {
      message: ''
    }
  },
  methods: {
    toserch () {
      this.$emit('toserch')
    }
  }
}
</script>

<style lang="less">
  .topHeader{
    width: 100%;
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e32c1a;
    div{
      width: 90%;
      height: 60%;
      color: #ffffff;
      font-size: 0.28rem;
      display: flex;
      padding-left: 0.2rem;
      align-items: center;
      justify-content: flex-start;
      background-color: rgba(250,250,250,0.2);
      border-radius: 0.1rem;
    }
  }
</style>
